import { DialogService, MessageType } from 'src/app/features/shared/services/dialog.service';
import { StorageProvider } from '../../storage.provider';
import { openNewTab } from '../../../../app/core/utils';
import { Logger } from '@uploadcam/common';

export class OpenStorageInteractor {
  constructor(
    private readonly dialog: DialogService,
    private readonly logger: Logger,
    private readonly provider: StorageProvider,
  ) {}

  public async execute(): Promise<void> {
    const closeFn = this.dialog.wait();

    try {
      const manager = await this.provider.provideManager();
      const url = manager.getProviderUrl();

      openNewTab(url);
    } catch (err) {
      this.logger.error(err);
      this.dialog.snack('Failed to open the storage homepage', MessageType.Error);
    } finally {
      closeFn();
    }
  }
}
